import React from 'react';
import {withStyles} from '@material-ui/core/styles';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import FilledInput from '@material-ui/core/FilledInput';
import classNames from "classnames";

const styles = theme => ({
    formControl: {
        margin: '0 5px 4px',
        minWidth: 120,
    },
    fillRoot: {
        backgroundColor: 'rgba(255, 255, 255, .9)',
        borderTopLeftRadius: 0,
        borderTopRightRadius: 0,
        boxShadow: '5px 5px 12px 0px rgba(0,0,0,0.3)',
        fontSize: '.9rem'
    },
    root: {
        padding: '8px 24px 8px 12px'
    },
    underline: {
        '&:after': {
            borderBottom: `2px solid #c5003a}`,
        }
    },
});

class SimpleSelect extends React.Component {
    handleChange = event => {
        this.props.onChange(event.target.value)
    };

    render() {
        const {classes, options, value, name, id, label} = this.props;

        return (
            <div style={{display: 'flex'}}>
                <FormControl variant="filled" className={classes.formControl} fullWidth>
                    <Select
                        value={value}
                        onChange={this.handleChange}
                        input={<FilledInput
                            className={classes.fillRoot}
                            classes={{
                                input: classes.root,
                                underline: classes.underline
                            }}
                            name={name}
                            id={id}/>}
                    >
                        {options.map(option =>
                            <MenuItem key={option.value} value={option.value}>{option.label}</MenuItem>)}
                    </Select>
                </FormControl>
            </div>
        )
    }
}

export default withStyles(styles)(SimpleSelect);